var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-container"},[_c('h3',[_vm._v(_vm._s(_vm.seller))]),_c('h2',[_vm._v(_vm._s(_vm.offer))])])}
var staticRenderFns = []

export { render, staticRenderFns }